import React from 'react';

import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../providers';

const useStyles = makeStyles((theme) => ({
    homePageCard: {
        display: 'flex',
        boxSizing: 'border-box',
        '@media (min-width: 40rem)': {
            width: '50%',
        },
        '@media (min-width: 56rem)': {
            width: '31.3333%',
        },
        '@media (max-width: 1188px)': {
            width: '47%',
        },
        '@media (max-width: 630px)': {
            width: '100%',
        },
    },
    title: {
        fontWeight: '600',
        fontSize: '1rem',
        lineHeight: '125%',
        color: theme.palette.text.tableHeaderGrey,
        letterSpacing: '0.15px',
        fontStyle: 'normal',
        boxSizing: 'border-box',
        marginBottom: '8px',
    },
    description: {
        fontSize: '0.75rem',
        lineHeight: '133%',
        color: theme.palette.text.tableHeaderGrey,
        letterSpacing: '-0.2px',
        fontWeight: '400',
        fontStyle: 'normal',
        flex: '1 1 auto',
        marginBottom: '1.25rem',
        boxSizing: 'border-box',
        '@media (max-width:660px)': {
            float: 'left',
            width: '100%',
            height: 'auto',
        },
    },
    externalPathIcon: {
        textAlign: 'right',
        color: '#ff0000',
    },
    subMenuSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: '0px',
        gap: '16px',
        clear: 'both',
        boxSizing: 'border-box',
        flexWrap: 'wrap',
    },
    subMenu: {
        fontFamily: '"Open Sans", sans-serif',
        border: 'none',
        background: 'none',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '0.75rem',
        lineHeight: '133%',
        display: 'flex',
        alignItems: 'center',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        color: '#3F5E20',
        flex: 'none',
        order: '2',
        flexGrow: '0',
        cursor: 'pointer',
        margin: 0,
        padding: 0,
        textDecoration: 'none',
        height: 'auto',
        boxSizing: 'border-box',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    card: {
        boxSizing: 'border-box',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.04)',
        borderRadius: '2px',
    },
    cardContent: {
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        padding: '24px 24px 28px 24px',
    },
}));

const HomePageCard = ({ item = {}, navigateTo, userType, authorities }) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            {Object.keys(item).length > 0 && (
                <div id={`card-${item.value.replace('.', '-')}`} className={classes.homePageCard}>
                    <div className={classes.card}>
                        <div className={classes.cardContent}>
                            {item.value && <div className={classes.title}>{t(item.value)}</div>}
                            {item.description && <div className={classes.description}>{t(item.description)}</div>}
                            {item.submenu && !!item.submenu.length && (
                                <div className={classes.subMenuSection}>
                                    {item.submenu
                                        .filter(({ cannotAccess }) => !cannotAccess || !cannotAccess(userType, authorities))
                                        .map((sub, index) => (
                                            <Button
                                                disableFocusRipple
                                                disableRipple
                                                role="link"
                                                aria-label={`${t('go.to').replace('{title}', `${t(item.value)} ${t(sub.value)}`)} ${
                                                    sub.externalPath ? '- ' + t('open.new.tab') : ''
                                                }`}
                                                key={index}
                                                className={classes.subMenu}
                                                onClick={(e) => navigateTo(e, sub.path, sub.externalPath)}>
                                                {t(sub.value)}
                                            </Button>
                                        ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default HomePageCard;
